export default {"src":"/_next/static/media/forbes.c488c786.svg","height":24,"width":96,"blurWidth":0,"blurHeight":0};